import type { ReactNode } from "react";
import { Headline, Text } from "@akina/presentation";

export function WebshopHeader({ title, subtitle }: Readonly<{ title: ReactNode; subtitle: string }>) {
  return (
    <div className="flex flex-col items-center gap-4 text-center">
      <Headline size="2xl" className="lg:text-3xl">
        {title}
      </Headline>
      <Text color="text-gray-800/70">{subtitle}</Text>
    </div>
  );
}
